// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonHideTheory_button__18UJn","badge":"ButtonHideTheory_badge__398xI"};